module.exports = __webpack_public_path__ + "img/icon_1.268cb795.png";